/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-utilities';
import type {
  TeachingPopoverCarouselNavButtonState,
  TeachingPopoverCarouselNavButtonSlots,
} from './TeachingPopoverCarouselNavButton.types';

/**
 * Render the final JSX of TeachingPopoverCarouselNavButton
 */
export const renderTeachingPopoverCarouselNavButton_unstable = (state: TeachingPopoverCarouselNavButtonState) => {
  assertSlots<TeachingPopoverCarouselNavButtonSlots>(state);

  return <state.root />;
};
